import { useRef } from 'react';

import useRect from '@lyearn/core/hooks/useRect';
import { HotspotContainer } from '@lyearn/lygo-blocks';
import { cn } from '@lyearn/style';
import { Stack, useForkRef } from '@lyearn/ui';
import { Image } from '@/components/Image';

import { ImageWithHotspotsProps } from './types';

const ImageWithHotspots: React.FC<ImageWithHotspotsProps> = (props) => {
  const { media, imageClassName = 'h-[33rem]', ...rest } = props;

  const divRef = useRef<HTMLDivElement>(null);
  const { ref: nodeContainerRef, width: nodeWidth, height } = useRect<HTMLDivElement>();
  const ref = useForkRef(nodeContainerRef, divRef);

  if (!media?.url) {
    return null;
  }

  return (
    <Stack
      ref={ref}
      className="group pointer-events-auto relative w-full cursor-pointer overflow-hidden rounded-8 border border-border"
      justifyContent="center">
      <Image
        alt={media.name || 'hotspot-image'}
        className={cn('w-full rounded-8', imageClassName)}
        layout="fill"
        objectFit="contain"
        src={media.url}
      />
      <HotspotContainer height={height} nodeElement={divRef.current!} width={nodeWidth} {...rest} />
    </Stack>
  );
};

export default ImageWithHotspots;
